import script from "./Form9.vue?vue&type=script&setup=true&lang=js"
export * from "./Form9.vue?vue&type=script&setup=true&lang=js"

import "./Form9.vue?vue&type=style&index=0&id=2fa9442a&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa9442a"]])

export default __exports__